// extracted by mini-css-extract-plugin
export default {"text":"GameEndingCountdown_text__rgP4R","gradient":"GameEndingCountdown_gradient__jgMy0"};